module.exports = __webpack_public_path__ + "static/ivana-atmojo-5edd1aeb19284ae51b7714d766cda476.jpg";